import { autoMount } from '../../../utils/autoMount';
import { CompanyPosts } from '../../../components/organisms/companyPosts';

autoMount({ CompanyPosts });
